import loadReCaptchaScript  from './recaptcha.js'

$(document).ready(function () {

    let accessForm = $('#access-check-address')
    let submitButton = accessForm.children('button')
    let emailInput = accessForm.find('input[type="email"]')

    let passwordInput = accessForm.find('input[type="password"]')
    let registerInputContainer = $('#register-inputs-container')
    let firstNameInput = registerInputContainer.find('input[name="first_name"]')
    let lastNameInput = registerInputContainer.find('input[name="last_name"]')
    let phoneNumber = registerInputContainer.find('input[name="cellphone"]')
    let checkboxTerm = accessForm.find('input[type="checkbox"]')
    let errorMessage = $('#access-feedback')

    let backupLinkText = accessForm.find('p')
    let backupLink = backupLinkText.find('a')

    let accessModal = new window.Modal($('#checkout-access-modal'))
    let accessModalForm = $('#access-modal-form')
    let modalFormPasswordInput = accessModalForm.find('input[name="password"]')

    loadReCaptchaScript()

    accessForm.on('submit', function (e) {
        e.preventDefault()

        grecaptcha.ready(function() {
            grecaptcha.execute('6LdiOUMoAAAAADn0sXowEnEbPJpt-YU_AmZAehdx', {action: 'submit'}).then(function(token) {
                $('#grecaptcha_token').val(token)
            })
        })

        let action = accessForm.data('action')
        if (action === 'check-email') {
            accessCheckEmail()
        } else if (action === 'register') {
            register()
        }
    })

    accessModalForm.on('submit', function (e) {
        e.preventDefault()

        checkCredentials()
    })

    backupLink.on('click', function (e) {
        backupLinkText.addClass('d-none')
        emailInput.attr('readonly', false)
        accessForm.data('action', 'check-email')
        submitButton.html('Continua')
        hideRegisterInputs()
        showAccessModal(true)
    })

    submitCheckCredentialsOnOrderPaid()

    function submitCheckCredentialsOnOrderPaid() {
        const orderAlreadyPaidComponent = accessForm.children('#order-already-paid');
        const order_paid = orderAlreadyPaidComponent.data('is_paid');
        const email = orderAlreadyPaidComponent.data('email')
        const order_state = orderAlreadyPaidComponent.data('order_state');
        const payment_method = orderAlreadyPaidComponent.data('payment_method');
        const order_pay_step = $("#order_steps").find("[data-step=pay]");
        const step_index = order_pay_step.find("span.multisteps-progress-index");

        if (email && order_state === 'billing_info') { // [DOOM-1102]
            if (order_paid) {
                step_index.addClass("bg-success");
                step_index.css("padding", "3px 6px");
                step_index.html("<i class=\"fa-solid fa-check text-light \"></i>");
                accessForm.submit();
            } else {
                if (payment_method === 'bank') {
                    accessForm.submit()
                }
            }
        }

        return;
    }

    function accessCheckEmail () {
        submitButton.attr('disabled', true)
        submitButton.html(
            'Controllo <i class="fa-solid fa-circle-notch fa-spin ms-2"></i>')

        $.post('/is-logged').
            done((response) => {
                if (response.result) {
                    window.location.replace('/checkout/pay')
                    return
                }

                $.post('/api/check-email', accessForm.serializeArray()).
                    done((response) => {
                        showAccessModal()
                    }).
                    fail((response) => {
                        emailInput.attr('readonly', true)
                        showRegisterInputs()
                        backupLinkText.removeClass('d-none')
                        submitButton.attr('disabled', false)
                        submitButton.html('Accetta e continua')
                        accessForm.data('action', 'register')
                    })
            })

    }

    function checkCredentials () {
        let modalFormSubmitButton = accessModalForm.children('button')
        modalFormSubmitButton.attr('disabled', true)
        modalFormSubmitButton.html(
            'Controllo <i class="fa-solid fa-circle-notch fa-spin ms-2"></i>')

        accessModalForm.children('input[type="password"]').
            removeClass('is-invalid')
        $.post('/login', accessModalForm.serializeArray()).
            done((response) => {
                modalFormSubmitButton.html(
                    'Accedo <i class="fa-solid fa-circle-notch fa-spin ms-2"></i>')
                analytics ? analytics("event", "login", {event_label: "shopping"}) : '';
                window.location.replace('/checkout/pay')
            }).
            fail((response) => {
                modalFormSubmitButton.attr('disabled', false)
                modalFormSubmitButton.html('Continua')
                modalFormPasswordInput.addClass('is-invalid')
            })
    }

    function register () {
        submitButton.attr('disabled', true)
        submitButton.html(
            'Un attimo... <i class="fa-solid fa-circle-notch fa-spin ms-2"></i>')

        let data = accessForm.serializeArray()
        data.push({ name: 'password_confirmation', value: passwordInput.val() })
        data.push({ name: 'email_confirmation', value: emailInput.val() })

        errorMessage.addClass('d-none')

        $.post('/registrati', data).
            done((response) => {
                submitButton.html(
                    'Fatto <i class="fa-solid fa-circle-notch fa-spin ms-2"></i>')
                const email = emailInput.val();
                try {
                    typeof(fbq) == "function" ? fbq("trackCustom", "NewCustomerPurchase", {email:email}) : '';
                    analytics ? analytics('event', "NewCustomerPurchase") : '';
                    analytics ? analytics('event', "sign_up", {event_label: 'shopping'}) : '';

                    ttq ? ttq.track('NewCustomerPurchase', {email:email}) : '';
                } catch (e) {
                    //
                }
                window.location.replace('/checkout/pay')
            }).
            fail((jqXHR, textStatus, errorThrown) => {
                submitButton.attr('disabled', false)
                submitButton.html('Registrati e continua')
                errorMessage.removeClass('d-none')
            })
    }

    function showRegisterInputs () {
        registerInputContainer.removeClass('d-none')
        passwordInput.attr('required', true)
        firstNameInput.attr('required', true)
        lastNameInput.attr('required', true)
        checkboxTerm.attr('required', true)
        phoneNumber.attr('required', true)
    }

    function hideRegisterInputs () {
        registerInputContainer.addClass('d-none')
        passwordInput.attr('required', false)
        firstNameInput.attr('required', false)
        lastNameInput.attr('required', false)
        checkboxTerm.attr('required', false)
        phoneNumber.attr('required', false)
    }

    function showAccessModal (clearEmail = false) {
        let accessEmailInput = accessModalForm.find('input[name="email"]');
        if (clearEmail) {
            accessEmailInput.val(null)
            accessEmailInput.attr('readonly', false)
        } else {
            accessEmailInput.val(emailInput.val())
        }
        submitButton.attr('disabled', false)
        submitButton.html('Continua')
        modalFormPasswordInput.removeClass('is-invalid')
        modalFormPasswordInput.val(null)
        accessModal.show()
    }
})

